/**
 * Accordion
 *
 * @selector .js-Accordion
 * @enabled true
 */

import BaseModule from '../../modules/BaseModule.js';
import fastdom from 'fastdom';

export default class Accordion extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);

        this.$accordionItemButtons = this.$el.find('.js-Accordion--item--btn');
        this.$ctaButtons = this.$el.find('.js-Accordion--cta');

        this.syncButtonWidth();
        this.bindListeners();

        return this;
    }

    bindListeners() {
        this.on(window, 'resize', this.onWindowResize);
        this.on('click', '.js-Accordion--item--btn', this.onAccordionToggle);
    }

    onAccordionToggle(e) {
        const $target = $(e.target);
        let eventData = $target.data('event');
        const openLabel = $target.data('tracking-open');
        const closeLabel = $target.data('tracking-close');

        if (eventData) {
            eventData.label = $target.attr('aria-expanded') === 'true' ? closeLabel : openLabel;
            this.pushEvent({ ...eventData });
        }
    }

    onWindowResize() {
        this.el.style.removeProperty('--button-width');
        this.syncButtonWidth();
    }

    syncButtonWidth() {
        let width = 0;

        function isVisible(el) {
            return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }

        fastdom.measure(() => {
            this.$ctaButtons
                .filter((index, el) => isVisible(el))
                .each((index, element) => {
                    width = Math.max(width, $(element).outerWidth());
                });
        });

        fastdom.mutate(() => {
            this.el.style.setProperty('--button-width', `${width}px`);
        });
    }

    pushEvent(event) {
        console.log('Push to dataLayer: ', event);
        (window.dataLayer || []).push(event);
    }
}
